import type * as api from '@gitbook/api-client';
import { Description, Dialog, DialogHeader, Heading } from '@gitbook/spine-react';

import { ContentSourceOpenAPIForm } from './ContentSourceOpenAPIForm';

interface EditContentSourceOpenAPIDialogProps {
    organizationId: string;
    computedContentSource: api.ComputedContentSourceRevisionOpenAPI;
    onSubmit: (source: api.ComputedContentSourceRevisionOpenAPI) => void;
}

export function EditContentSourceOpenAPIDialog(props: EditContentSourceOpenAPIDialogProps) {
    const { computedContentSource } = props;
    return (
        <Dialog>
            <DialogHeader className="w-screen max-w-xl">
                <Heading>OpenAPI Reference settings</Heading>
                <Description>
                    Choose the OpenAPI spec used to generate your reference. Optionally include a
                    model reference page listing all defined schemas.
                </Description>
            </DialogHeader>
            <ContentSourceOpenAPIForm
                organizationId={props.organizationId}
                onSubmit={props.onSubmit}
                buttonLabel="Apply changes"
                defaultValues={{
                    models: computedContentSource.props.models,
                    specSlug:
                        computedContentSource.dependencies &&
                        'spec' in computedContentSource.dependencies &&
                        computedContentSource.dependencies.spec.ref.kind === 'openapi'
                            ? computedContentSource.dependencies.spec.ref.spec
                            : null,
                }}
            />
        </Dialog>
    );
}
